/* eslint-disable indent */
var app = angular.module('myApp', [
  'ngRoute',
  'ngMessages',
  'ngSanitize',
  'ui.bootstrap',
  'common.services',
  'common.directives',
  'ui.mask',
  'moment-picker'
])

app.filter('phonenumber', [
  function() {
    return function(input) {
      var inputTmp = input || ''
      var out = ''
      switch (inputTmp.length) {
        case 9: // 30/123-4567
          out = ' (' +
            inputTmp.slice(0, 2) + ') ' +
            inputTmp.slice(2, 5) + '-' +
            inputTmp.slice(5)
          break
        case 11: // 06 30/123-456
          out = inputTmp.slice(0, 2) + ' ' +
            inputTmp.slice(2, 4) + '/' +
            inputTmp.slice(4, 7) + '-' +
            inputTmp.slice(7)
          break
        default:
          return inputTmp
      }
      return out
    }
  }
])

app.filter('taxnumber', [
  function() {
    return function(input) {
      var inputTmp = input || ''
      var out = ''

      // 99999999-9-99
      out = inputTmp.slice(0, 8) + '-' + inputTmp.slice(8, 9) + '-' + inputTmp.slice(9)
      return out
    }
  }
])
